module.exports = __webpack_public_path__ + "static/img/kc.7ff47291.png";